import { isAnalyticsSuppressed } from '../analytics';

let clarityLoaded = false;

export function resolveClarityProjectId(siteSettings) {
  const fromSite = String(siteSettings?.store_copy?.clarity_project_id || '').trim();
  if (fromSite) return fromSite;
  const fromEnv = String(process.env.REACT_APP_CLARITY_PROJECT_ID || '').trim();
  return fromEnv || '';
}

export function initClarity(projectId) {
  if (isAnalyticsSuppressed() || clarityLoaded) return false;
  const id = String(projectId || '').trim();
  if (!id) return false;
  if (typeof window === 'undefined') return false;
  if (window.clarity) {
    clarityLoaded = true;
    return true;
  }
  ((c, l, a, r, i, t, y) => {
    c[a] =
      c[a] ||
      function clarityStub(...args) {
        (c[a].q = c[a].q || []).push(args);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', id);
  clarityLoaded = true;
  return true;
}
